export default "__VITE_ASSET__C9$C1yBw__"